import { useDispatch, useSelector } from 'react-redux'
import Input from '../../../../../UI/Input/Input'
import { setLocal } from '../../../../../../redux/action/local'
import props from '../../../../../../redux/props'

const GeneralObjectCriteria = () => {
  const translations = useSelector((state) => state.translations)
  const purchaseProfile = useSelector((state) => state.PURCHASE_PROFILE)
  const dispatch = useDispatch()

  const update = (key) => (value) => {
    const updatePurchaseProfile = { ...purchaseProfile, generalObjectCriteria: { ...purchaseProfile.generalObjectCriteria, [key]: value } }
    // dispatch(setNewPurchaseProfile(updatePurchaseProfile))
    dispatch(setLocal(props.PURCHASE_PROFILE, updatePurchaseProfile))
  }

  return (
    <div className="wrapper">
      <div className="group">
        <div className="label">{translations['my-objects.pipeline.location-criteria.general-object-criteria.residental-units-from']}</div>
        <div className="values">
          <Input
            type="number"
            value={purchaseProfile.generalObjectCriteria.residentialUnitsFrom}
            onChange={update('residentialUnitsFrom')}
            placeholder={translations['my-objects.pipeline.location-criteria.general-object-criteria.residental-units-from']}
          />
        </div>
      </div>
      <div className="group">
        <div className="label">{translations['my-objects.pipeline.location-criteria.general-object-criteria.residental-units-until']}</div>
        <div className="values">
          <div className="values">
            <Input
              type="number"
              value={purchaseProfile.generalObjectCriteria.residentialUnitsUntil}
              onChange={update('residentialUnitsUntil')}
              placeholder={translations['my-objects.pipeline.location-criteria.general-object-criteria.residental-units-until']}
            />
          </div>
        </div>
      </div>
      <div className="group">
        <div className="label">{translations['my-objects.pipeline.location-criteria.general-object-criteria.living-space-from']}</div>
        <div className="values">
          <Input
            type="number"
            value={purchaseProfile.generalObjectCriteria.livingSpaceFrom}
            onChange={update('livingSpaceFrom')}
            placeholder={translations['my-objects.pipeline.location-criteria.general-object-criteria.living-space-from']}
          />
        </div>
      </div>
      <div className="group">
        <div className="label">{translations['my-objects.pipeline.location-criteria.general-object-criteria.living-space-until']}</div>
        <div className="values">
          <div className="values">
            <Input
              type="number"
              value={purchaseProfile.generalObjectCriteria.livingSpaceUntil}
              onChange={update('livingSpaceUntil')}
              placeholder={translations['my-objects.pipeline.location-criteria.general-object-criteria.living-space-until']}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default GeneralObjectCriteria
